import { TrainingSectionType } from '../models/training-section.model';

export function concatCoordinates(section: TrainingSectionType): L.LatLngExpression[] {
  return section.coordinates.flatMap(({ lat, lng, latitude, longitude }) => {
    const resolvedLat: number | null = lat ?? latitude;
    const resolvedLng: number | null = lng ?? longitude;
    return resolvedLat != null && resolvedLng != null ? [[resolvedLat, resolvedLng]] : [];
  });
}
